import sls from "react-secure-storage";


const setSession = (session) => {
  sls.setItem('session', session);
}

const getSession = () => {
  return sls.getItem('session');
}

const delSession = () => {
  sls.removeItem('session');
}

const setParams = (params) => {
  const session = getSession();
  session.params = params;
  setSession(session);
}

const getParams = () => {
  const session = getSession();
  return session?.params;
}

const addParam = (key, value) => {
  const session = getSession();
  session.params[key] = value;
  setSession(session); 
}

const getParam = (key) => {
  const session = getSession();
  return session.params[key];
}

const delParam = (key) => {
  const session = getSession();
  delete session.params[key];
  setSession(session);
}

const setActive = (active) => {
  const session = getSession();
  session.active = active;
  setSession(session);
}

const getActive = () => {
  const session = getSession();
  return session?.active;
}

const addStore = (key, value) => {
  sls.setItem(key, value);
}

const getStore = (key) => {
  return sls.getItem(key);
}

export {
  setSession,
  getSession,
  delSession,
  addParam,
  getParam,
  delParam,
  setParams,
  getParams,
  setActive,
  getActive,
  addStore,
  getStore
};